module.exports = __webpack_public_path__ + "img/171820.b5086f96.png";